"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.migratePlanSteps = migratePlanSteps;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
const PLAN_FILE = /-plan-\d+\.md$/;
/** Recursively collect plan files under loom/, skipping the .archive tree. */
async function findPlanFiles(loomDir, fsx) {
    const out = [];
    async function walk(dir) {
        let entries;
        try {
            entries = await fsx.readdir(dir, { withFileTypes: true });
        }
        catch {
            return;
        }
        for (const e of entries) {
            if (e.name === '.archive')
                continue;
            const p = path.join(dir, e.name);
            if (e.isDirectory()) {
                await walk(p);
            }
            else if (e.isFile() && PLAN_FILE.test(e.name)) {
                out.push(p);
            }
        }
    }
    await walk(loomDir);
    return out;
}
/**
 * Migrate legacy (body-table-backed) plans to frontmatter-native steps. Idempotent:
 * already-native plans are skipped. Never destructive — a plan whose body table can't
 * be parsed is reported `unparseable` and left exactly as-is (so a foreign/legacy table
 * is never silently emptied). The actual body→steps parse is done by the loader; this
 * use-case only re-saves legacy plans with the frontmatter-native marker set.
 */
async function migratePlanSteps(input, deps) {
    const loomDir = path.join(input.loomRoot, 'loom');
    const files = await findPlanFiles(loomDir, deps.fs);
    const results = [];
    for (const filePath of files) {
        let doc;
        try {
            doc = await deps.loadDoc(filePath);
        }
        catch {
            continue; // unreadable / malformed frontmatter — skip silently, not our concern here
        }
        if (doc.type !== 'plan')
            continue;
        if (input.docId && doc.id !== input.docId && path.basename(filePath, '.md') !== input.docId) {
            continue;
        }
        // Loader sets this true when it read structured steps from frontmatter.
        if (doc._stepsFromFrontmatter === true) {
            results.push({ filePath, planId: doc.id, status: 'already-native', stepCount: doc.steps?.length ?? 0 });
            continue;
        }
        const steps = doc.steps ?? [];
        if (steps.length === 0) {
            // Distinguish "genuinely stepless" from "has a table the parser couldn't read".
            const status = (0, dist_1.stepsSectionHasRows)(doc.content ?? '') ? 'unparseable' : 'no-steps';
            results.push({ filePath, planId: doc.id, status, stepCount: 0 });
            continue;
        }
        if (!input.dryRun) {
            doc._stepsFromFrontmatter = true;
            await deps.saveDoc(doc, filePath);
        }
        results.push({ filePath, planId: doc.id, status: 'migrated', stepCount: steps.length });
    }
    return results;
}
